/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Design_Settings_Preview_ButtonInputs */

const en_admin_design_settings_preview_button = /** @type {(inputs: Admin_Design_Settings_Preview_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Example button`)
};

const de_admin_design_settings_preview_button = /** @type {(inputs: Admin_Design_Settings_Preview_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beispiel-Button`)
};

/**
* | output |
* | --- |
* | "Example button" |
*
* @param {Admin_Design_Settings_Preview_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_design_settings_preview_button = /** @type {((inputs?: Admin_Design_Settings_Preview_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Design_Settings_Preview_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_design_settings_preview_button(inputs)
	return en_admin_design_settings_preview_button(inputs)
});